module.exports = __webpack_public_path__ + "static/media/logout.ff5ec16a.gif";